import { render, staticRenderFns } from "./CalendarEventFooterDropdown.vue?vue&type=template&id=dc38a62c&scoped=true&"
import script from "./CalendarEventFooterDropdown.vue?vue&type=script&lang=ts&"
export * from "./CalendarEventFooterDropdown.vue?vue&type=script&lang=ts&"
import style0 from "./CalendarEventFooterDropdown.vue?vue&type=style&index=0&id=dc38a62c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc38a62c",
  null
  
)

export default component.exports